module.exports = __webpack_public_path__ + "img/1minute.cd58ccd.svg";